"use client";

import { Show } from "@clerk/nextjs";
import {
  AddToCartButton,
  type AddToCartButtonProps,
} from "@/cart/components/AddToCartButton";
import { DigitalServiceLoginRequiredInfoBox } from "@/products/components/DigitalServiceLoginRequiredInfoBox";

export const DigitalServicePurchaseButton = ({
  ...props
}: AddToCartButtonProps) => {
  return (
    <Show when="signed-in" fallback={<DigitalServiceLoginRequiredInfoBox />}>
      <AddToCartButton {...props} />
    </Show>
  );
};
